import useMediaQuery from "../../../hooks/useMediaQuery";
import { IHeaderType } from "../../../types/types";
import Title from "../../title/Title";



type Props = {
  titleText: string;
  textColor: string;
  style: {};
  cName?: string;
  type: IHeaderType;
};


const SectionHeaderTitle = (props: Props) => {
  const isNonMobile = useMediaQuery("(min-width:900px)");


  const titleStyle = {
    maxWidth: `${isNonMobile ? '429px' : ''}`
  };


  return (
    <>
      <Title
        text={props.titleText}
        textColor="#EB8145"
        style={{ ...titleStyle }}
        type={props.type}
      />
    </>
  );
};

export default SectionHeaderTitle;
